<template>
  <div class="messageContainer">
    <div class="myMessage">
      <div class="title">我的消息</div>
      <van-pull-refresh
        style="overflow: initial;min-height: 100vh"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <van-list
          class="questionnaire"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="50"
        >
          <div
            class="questionnaireItem"
            v-for="(item, index) in questionnaireData"
            :key="index"
            @click="view(item.id)"
          >
            <div
              class="questionnaireTitle"
              :style="{ color: item.type ? '#323232' : '#969696' }"
            >
              {{ item.title }}
            </div>
            <div
              class="questionnaireTime"
              :style="{ color: item.type ? '#03B187' : '#969696' }"
            >
              <SvgIcon
                :icon-class="item.type ? 'icondate' : 'icondate-hui'"
              ></SvgIcon>
              {{ item.time }}
            </div>
            <div class="questionnaireContent">{{ item.content }}</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <back-to :path="'/'"></back-to>
  </div>
</template>
<script>
// import api from "@/api";
import backTo from "@/components/back";
import { PullRefresh } from "vant";
import { List } from "vant";
export default {
  components: { backTo, [List.name]: List, [PullRefresh.name]: PullRefresh },
  data() {
    return {
      questionnaireData: [
        {
          id: 1,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: true
        },
        {
          id: 2,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: false
        },
        {
          id: 3,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: true
        },
        {
          id: 4,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: false
        },
        {
          id: 5,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: false
        },
        {
          id: 6,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: true
        },
        {
          id: 7,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: false
        },
        {
          id: 8,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: true
        },
        {
          id: 9,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: false
        },
        {
          id: 10,
          title: "计算机基础课程质量评价问卷（第1学期）",
          time: "2019-8-21 17:24",
          content: "西安科技大学2019年第1学期期末成绩已公布，请登录查看。",
          type: true
        }
      ],
      loading: false,
      finished: false,
      isLoading: false
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast({
          message: "刷新成功",
          duration: 1000,
          position: "bottom"
        });
        this.isLoading = false;
      }, 1000);
    },
    view(id) {
      console.log(id);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.questionnaireData = this.questionnaireData.concat(
          Object.assign([], this.questionnaireData)
        );
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.questionnaireData.length >= 40) {
          this.finished = true;
        }
      }, 500);
    },
    // 去问卷
    toQuestionaire() {
      this.$router.push({
        path: "/myQuestionaire"
      });
    },
    // 课程达成记录
    toAchieving() {
      this.$router.push({
        path: "/achievingCourses"
      });
    },
    // 能力预警记录
    toWarning() {
      this.$router.push({
        path: "/capacityWarning"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.messageContainer {
  background-color: #fff;
  .myMessage {
    padding: 0 24px;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    padding-bottom: 30px;
    position: relative;
    .title {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 100px;
      z-index: 99;
      background-color: #fff;
      padding-top: 40px;
      text-align: center;
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      letter-spacing: $letter-spacing;
    }
    .questionnaire {
      margin-top: 120px;
      // padding-bottom: 30px;
      .questionnaireItem {
        padding: 30px 30px;
        margin-top: 30px;
        height: 206px;
        background: rgba(255, 255, 255, 1);
        box-shadow: $box-shadow;
        border-radius: 10px;
        position: relative;
        .questionnaireTitle {
          font-size: 30px;
          font-family: PingFangSC;
          font-weight: 700;
          color: rgba(50, 50, 50, 1);
          letter-spacing: $letter-spacing;
        }
        .questionnaireTime {
          font-size: 20px;
          font-family: PingFangSC;
          color: $color-primary;
          margin-top: 20px;
        }
        .questionnaireContent {
          font-size: 22px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #969696;
          margin-top: 25px;
        }
      }
    }
  }
}
</style>
